import { render, staticRenderFns } from "./_workspaces.vue?vue&type=template&id=62f8e630&scoped=true"
import script from "./_workspaces.vue?vue&type=script&lang=js"
export * from "./_workspaces.vue?vue&type=script&lang=js"
import style0 from "./_workspaces.vue?vue&type=style&index=0&id=62f8e630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f8e630",
  null
  
)

export default component.exports